<template>
  <main class="error-page">
    <div class="error-page__wrapper">
      <div class="lottie__wrapper">
        <div class="lottie"></div>
      </div>
      <div class="error-page-text">
        <p>Oops... something went wrong!</p>
        <router-link to="/">
          <div class="c-button">
            <span>Go to Homepage</span>
          </div>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
import lottie from 'lottie-web';
import anime from 'animejs';

import animationData from '@/assets/data/404.json';

import { qs } from '@/scripts/utils';

export default {
  name: 'errorPage',

  mounted() {
    lottie.loadAnimation({
      container: qs('.lottie', this.$el),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        clearCanvas: true,
        preserveAspectRatio: 'none',
      },
    });

    const p = qs('.error-page-text p');
    const a = qs('.error-page-text a');

    const basicTimeline = anime.timeline();

    basicTimeline.add({
      targets: p,
      duration: 400,
      opacity: [0, 1],
      translateY: [40, 0],
      easing: 'easeInOutSine',
      delay: 400,
    })
    .add({
      targets: a,
      duration: 400,
      opacity: [0, 1],
      translateY: [40, 0],
      easing: 'easeInOutSine',
      delay: 100,
    });
  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.error-page {
  position: relative;
  background: rgb(126, 205, 218);
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    margin-top: -160px;

    @include mq(ipadL) {
      margin-top: 0;
    }
  }

  .lottie__wrapper {
    max-height: 80vh;
    height: calc(var(--vh, 1vh) * 80);
  }

  .error-page-text {
    position: relative;
    z-index: 2;
    width: 100%;
    text-align: center;

    p {
      font-size: 1rem;
      color: $color-white;
      font-weight: 700;
      margin-bottom: 18px;
    }
  }
}

.c-button {
  display: inline-block;
  position: relative;
  padding: 0;

  background-color: transparent;
  border: none;
  outline: transparent;

  cursor: pointer;

  & span {
    position: relative;
    display: inline-block;
    padding: 14px 30px;
    font-weight: 700;
    color: $color-light;

    z-index: 5;

    transition: transform 0.4s $global-ease;
  }

  & span,
  &::before,
  &::after {
    display: inline-block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &::before,
  &::after {
    content: '';

    position: absolute;

    border: 1px solid $color-text;
    border-radius: 18px;

    transition: transform 0.4s $global-ease;
    background-color: #FB8D83;
  }

  &::before {
    transform: translateX(3px) translateY(3px);
    background-color: #C38B87;
  }

  @at-root .pointerevents:not(.touchevents) &:hover::after,
  .no-pointerevents.no-touchevents &:hover::after {
    transform: translateX(3px) translateY(3px);
  }

  @at-root .pointerevents:not(.touchevents) &:hover span,
  .no-pointerevents.no-touchevents &:hover span {
    transform: translateX(3px) translateY(3px);
  }
}
</style>


<style lang="scss">
[data-page="errorPage"] .lottie__wrapper svg {
  width: auto !important;
  height: 70vh !important;
  height: calc(var(--vh, 1vh) * 70) !important;
}
</style>
